import { render, staticRenderFns } from "./InfosetExportHeader.vue?vue&type=template&id=0ef066ff&scoped=true&"
import script from "./InfosetExportHeader.vue?vue&type=script&lang=ts&"
export * from "./InfosetExportHeader.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetExportHeader.vue?vue&type=style&index=0&id=0ef066ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef066ff",
  null
  
)

export default component.exports